'use client';
import * as React from 'react';
import { TableHeadContext } from './table.context.js';
import { createComponent } from '../core/create-component.js';

/**
 * @subcomponent Table
 */ const TableHead = createComponent({
    displayName: 'TableHead',
    root: 'thead',
    propConfig: {
        classNames: [
            'swan-thead'
        ],
        wrapRoot (_props, _derivedProps, element) {
            return /*#__PURE__*/ React.createElement(TableHeadContext.Provider, {
                value: true
            }, element);
        }
    }
});

export { TableHead };
